









































































































import { GradesDeHorarioProps,
  SlotsProps } from '@/types/interfaces/SolicitacaoCirurgia'
import Vue from 'vue'
import { Component, Emit, Prop, Watch } from 'vue-property-decorator'

@Component
export default class RoomSchedulingSlot extends Vue {
  @Prop({ required: true })
  readonly gradesDeHorario!: GradesDeHorarioProps

  @Prop({ required: true })
  readonly hasSchedulingActive!: boolean

  isMenuOpen: boolean = false
  slotSelected: SlotsProps | undefined

  onCloseModal() {
    this.isMenuOpen = false
    this.slotSelected = undefined
    this.$emit('onCancelSlotScheduling')
  }

  onClickSlot(slot: SlotsProps) {
    if (
      this.slotSelected
      && this.slotSelected.horaFim === slot.horaFim
      && this.slotSelected.horaInicio === slot.horaInicio
    ) {
      this.slotSelected = undefined
      this.$forceUpdate()
      return
    }
    this.slotSelected = slot
    this.$forceUpdate()
  }

  verifySlot(slot: SlotsProps) {
    if (
      this.slotSelected
      && slot.horaFim === this.slotSelected.horaFim
      && this.slotSelected.horaInicio === slot.horaInicio
    ) {
      return true
    }
    return false
  }

  hasPreferentialSlot() {
    if (!this.gradesDeHorario.slots) return false
    let hasPreferential = false
    this.gradesDeHorario.slots.forEach((slot) => {
      if (slot.tipo && slot.tipo === 'Preferencial') {
        hasPreferential = true
      }
    })
    return hasPreferential
  }

  @Emit('clickSlot')
  onSave() {
    if (!this.slotSelected) return
    this.isMenuOpen = false
    const slotPayload = {
      salaId: this.gradesDeHorario.salaId,
      centroCirurgicoId: this.gradesDeHorario.centroCirurgicoId,
      slotSelected: this.slotSelected,
    }
    this.$emit('clickSlot', slotPayload)
  }
}
